import { render, staticRenderFns } from "./SingleColor.vue?vue&type=template&id=2df69cc8&scoped=true&"
import script from "./SingleColor.vue?vue&type=script&lang=js&"
export * from "./SingleColor.vue?vue&type=script&lang=js&"
import style0 from "./SingleColor.vue?vue&type=style&index=0&id=2df69cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df69cc8",
  null
  
)

export default component.exports